import useOctadeskChatStore from '../stores/useOctadeskChatStore'
import {
  applyOctadeskPointerEvents,
  ensureOctadeskPanelLayout,
  resetOctadeskLayoutSignature,
  startWatchingOctadeskPanelVisibility,
  stopOctadeskLayoutEffects
} from './useOctadeskDomLayout'
import { invokeOctadeskHide, invokeOctadeskShow } from './useOctadeskWindow'

export function closeOctadeskChat (): void {
  const store = useOctadeskChatStore()

  store.clearOpenRequested()
  stopOctadeskLayoutEffects()

  invokeOctadeskHide()

  store.setOpen(false)
  resetOctadeskLayoutSignature()
  applyOctadeskPointerEvents()
}

export function openOctadeskChat (): void {
  const store = useOctadeskChatStore()

  store.markOpenRequested()
  store.setOpen(true)
  applyOctadeskPointerEvents()
  startWatchingOctadeskPanelVisibility()

  invokeOctadeskShow()

  ensureOctadeskPanelLayout()
}

export function toggleOctadeskChat (): void {
  const store = useOctadeskChatStore()

  if (store.isOpen) {
    closeOctadeskChat()
    return
  }

  openOctadeskChat()
}
